import classNames from "classnames"
import { renderRichText } from "gatsby-source-storyblok"
import React from "react"

import { getTextAlignClass } from "../../utils/text"

import { Color } from "@constants/V2/color"
import { getTextColorClass } from "@utils/V2/color"

type Props = {
  content: any
  textColor?: Color
  linkColor?: Color
  textAlign?: Storyblok.TextAlign
}

const RichTextElement = ({
  content,
  textColor = Color.Black,
  linkColor = Color.Blue,
  textAlign,
}: Props) => {
  const linkTextColor = getTextColorClass(linkColor)
  return (
    <div
      className={classNames(
        "[&_a]:underline [&_a]:decoration-current [&_li]:ml-16 [&_li_p]:pb-0 [&_ol]:list-[inherit] [&_ol]:!p-0 [&_ol]:pb-24 [&_p]:!mb-0 [&_p]:pb-24 [&_ul]:list-[inherit] [&_ul]:!p-0 [&_ul]:pb-24",
        getTextColorClass(textColor),
        getTextAlignClass(textAlign),
        `[&_a]:${linkTextColor}`
      )}
      dangerouslySetInnerHTML={{ __html: renderRichText(content) }}
    />
  )
}

export default RichTextElement
